module.exports = __webpack_public_path__ + "static/media/AvenirNext-Bold-01.61887e1e.ttf";